import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=20d7462c&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Permissions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Permissions.vue?vue&type=style&index=1&id=20d7462c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7462c",
  null
  
)

export default component.exports